import React, {Fragment} from "react";
import PropTypes from "prop-types";

const Close = (props) => {
  return (
    <Fragment>
      <i className="fa fa-trash close" aria-hidden="true" onClick = {(e) => props.removeGrade(e.target)}></i>
    </Fragment>
  );
};

Close.propTypes = {};

export default Close;
